import React from 'react';
import { useApp, useTime } from '../_contexts';

import { TimelineOptions } from './';

export function TimelineName({ timeline }) {
  const { editMode } = useApp();
  const { scrollPosition } = useTime();

  // console.log(scrollPosition)
  const offset =
    scrollPosition > window.innerWidth / 2
      ? Math.abs(scrollPosition - window.innerWidth / 2)
      : 0;

  return (
    <div className="chronos-timeline-title" style={{ left: offset }}>
      <span className="chronos-timeline-name">{timeline.title}</span>
      {editMode && <TimelineOptions timeline={timeline} />}
    </div>
  );
}
